"use strict";
/**
 * CatalogItem Types
 *
 * Type definitions for catalog items (products/services) that sync with QVET.
 */
Object.defineProperty(exports, "__esModule", { value: true });
